import { checkUser } from "@/api/system";
import config, { Patform } from "@/config";
import { getHash, removeHash } from "@/utils";

// 判断是否获取openid，没有则前往获取
const useCheckWxOpenid = () => {
  if (config.env == Patform.wechat && !localStorage.getItem('openid')) {
    useWxAuth();
    return false;
  } else {
    return true;
  }
}

const useWxAuth = () => {
  // 先清理相关openid
  removeHash('openid');
  removeHash('token');
  removeHash('action');
  window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${
    config.wechatAppid
  }&redirect_uri=http://${
    config.loginAndPayHost
  }/login/loginGxfwechat?state=${encodeURIComponent(
    window.location.href.replaceAll("#", "/,,,/")
  )}&response_type=code&scope=snsapi_userinfo&forcePopup=true#wechat_redirect`;
}

// 将url中的openid保存并清除url中的openid
const useRefreshWxOpenid = async () => {
  const openid = getHash('openid');
  if (openid) {
    try {
      await checkUser({
        openid: openid,
      });
      localStorage.setItem('openid', openid);
      removeHash('openid');
      removeHash('token');
      removeHash('action');
    } catch (error) {
      console.log('检查用户失败：', error);
    }
  }
}

const toCheckUser = async () => {
  if (localStorage.getItem('openid')) {
    await checkUser({
      openid: localStorage.getItem('openid'),
    })
  }
}

export default useCheckWxOpenid;
export { useRefreshWxOpenid, useWxAuth, toCheckUser };